<div class="paginator-main-container">
  <div class="filters-paginator">
    <div class="search-and-filters">
      @if (showClearFiltersButton) {
        <ui-atom-button
          [disabled]="clearFiltersDisabled"
          [fullWidth]="false"
          [withShadow]="false"
          [tooltip]="'tables.filters.resetTooltip' | translate"
          rules="main"
          styling="text"
          [text]="'tables.filters.reset' | translate"
          (click)="onClearFiltersClick()"
        />
      }

      @if (showGlobalSearch) {
        <div class="global-search-container">
          <ui-molecule-input
            textId="globalSearch"
            [placeholder]="'tables.filters.globalSearch' | translate"
            [formControl]="searchControl"
          />
          @if (isSearching) {
            <div class="search-loader">
              <div class="spinner"></div>
            </div>
          } @else if (searchControl.value && searchControl.value.trim() !== '') {
            <button
              class="clear-search-btn"
              (click)="clearSearch()"
              [title]="'Clear search' | translate"
              type="button"
            >
              ×
            </button>
          }
        </div>
      }

      @if (showExportButton) {
        <ui-atom-button
          [fullWidth]="false"
          [withShadow]="false"
          [tooltip]="exportTooltipKey | translate"
          rules="main"
          styling="outlined"
          [text]="exportLabelKey | translate"
          (click)="onExportClick()"
        />
      }
    </div>

    <div class="ui-molecule-mat-table--toolbar">
      <ng-content></ng-content>
    </div>
  </div>

  <mat-paginator
    [length]="length"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="showFirstLastButtons"
    (page)="pageChange.emit($event)"
  />
</div>
